import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ComparisonTable } from './components/ComparisonTable';
import { StatsSection } from './components/StatsSection';
import { GallerySection } from './components/GallerySection';
import { PackagesSection } from './components/PackagesSection';
import { CoverageMap } from './components/CoverageMap';
import { HowItWorks } from './components/HowItWorks';
import { TrustFactors } from './components/TrustFactors';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MarqueeBanner } from './components/MarqueeBanner';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-black text-white font-inter selection:bg-brand-red selection:text-white" data-id="element-1">
        <UrgencyBanner data-id="element-2" />
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <MarqueeBanner texts={['NO HIDDEN FEES', 'FIXED PRICE', 'LICENSED & INSURED', 'TAMPA BAY']} direction="right" speed={25} size="sm" textColor="text-brand-red/10" dotColor="bg-brand-yellow/15" data-id="element-6" />
          <ProblemSection data-id="element-7" />
          <ComparisonTable data-id="element-8" />
          <StatsSection data-id="element-9" />
          <GallerySection data-id="element-10" />
          <PackagesSection data-id="element-11" />
          <MarqueeBanner texts={['BUY NOW', 'SAVE BIG', 'WEB EXCLUSIVE', 'ZERO STRESS']} direction="left" speed={18} size="md" textColor="text-brand-yellow/[0.06]" dotColor="bg-brand-red/20" data-id="element-12" />
          <CoverageMap data-id="element-13" />
          <HowItWorks data-id="element-14" />
          <TrustFactors data-id="element-15" />
          <MarqueeBanner texts={['10,500+ MOVES', '68 UNITS', '99% SATISFACTION', '5 STAR RATED']} direction="right" speed={22} size="sm" textColor="text-white/[0.04]" dotColor="bg-brand-red/15" data-id="element-16" />
          <TestimonialsSection data-id="element-17" />
          <FAQ data-id="element-18" />
        </main>
        <Footer data-id="element-19" />
      </div>
    </LanguageProvider>;
}